export default "__VITE_ASSET__hN5qouAT__";